import {
  Alert,
  ErrorBoundary,
  LazyBarChart,
  Skeleton,
} from "@prismicio/editor-ui"
import { type ComponentProps, Suspense } from "react"

export function DeferredBarChart(props: ComponentProps<typeof LazyBarChart>) {
  return (
    <ErrorBoundary
      renderError={() => (
        <Alert
          icon="alert"
          title="Oops! We couldn't load the Chart"
          color="error"
          noShadow
          footerButtons={{
            action: {
              onClick: () => window.location.reload(),
              text: "Refresh page",
            },
          }}
        />
      )}
    >
      <Suspense fallback={<Skeleton height={props.height} width="100%" />}>
        <LazyBarChart {...props} />
      </Suspense>
    </ErrorBoundary>
  )
}
